import { Box, Paper } from '@mui/material';
import React from 'react';
import { darken, lighten } from '@mui/system';
import { createGlobalStyle } from 'styled-components';
import JsxParser from 'react-jsx-parser';

const GlobalStyles = createGlobalStyle`
html {
  --mui-palette-primary-main: ${(props) => props.primaryColor} !important;
  --mui-palette-primary-mainChannel: ${(props) => lighten(props.primaryColor, 0.9)} !important;
  --mui-palette-primary-dark: ${(props) => darken(props.primaryColor, 0.2)} !important;
  --template-palette-background-default: ${(props) => props.backgroundColor};
}
`;

export default function EventDetails({ details }) {
  return (
    <>
      <GlobalStyles
        primaryColor={details?.event?.colors?.primary || '#1976d2'}
        backgroundColor={details?.event?.colors?.background || '#ffffff'}
      />
      {details.event?.logoUrl && (
        <Box sx={{ maxWidth: 800, mx: 'auto', my: 2, textAlign: 'center' }}>
          <img src={details.event?.logoUrl} alt="logo" style={{ width: '80%' }} />
        </Box>
      )}
      <Paper sx={{ maxWidth: 800, boxShadow: 3, p: 4, mx: 'auto', mb: 4 }}>
        <Box sx={{ padding: 4, maxWidth: 800, margin: 'auto', paddingTop: 0 }}>
          <JsxParser
            jsx={details?.event?.description}
            autoCloseVoidElements
          />
        </Box>
      </Paper>
    </>
  );
}
